var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { observable, untracked, transaction, extras, ObservableMap as MobxObservableMap, useStrict, } from 'mobx';
import { CreateModuleProvider } from './providers';
import { BaseControllerClass } from 'cerebral';
import { extractModuleProp, getModule, throwError } from 'cerebral/internal';
import { updateIn } from './utils';
import Model from './Model';
export { ConnectFactory, ModuleConnectFactory } from './connect';
export { pathFor } from './paths';
export { SequenceFactory, SequenceWithPropsFactory, } from 'function-tree/fluent';
export { Computed } from './Computed';
export { default as Container } from './Container';
export function Dictionary(values) {
    return new MobxObservableMap(values);
}
// mobx uses extra fields in modules and therefore needs to declare it's own `Module` constructor.
export { Module, Provider, CerebralError } from 'cerebral';
var FluentController = /** @class */ (function (_super) {
    __extends(FluentController, _super);
    function FluentController(rootModule, options) {
        var _this = _super.call(this, rootModule, options, {
            executeBranchWrapper: function (cb) {
                extras.allowStateChanges(true, function () { return untracked(function () { return transaction(cb); }); });
            },
        }) || this;
        useStrict(typeof options.useStrict === 'undefined' ? true : options.useStrict);
        _this.state = _this.model.state;
        _this.signals = extractModuleProp(_this.module, 'signals', function (signals, module) {
            return Object.keys(signals).reduce(function (runableSignals, key) {
                if ('run' in signals[key]) {
                    runableSignals[key] = signals[key].run;
                }
                else {
                    runableSignals[key] = signals[key];
                }
                return runableSignals;
            }, {});
        });
        _this.contextProviders.module = CreateModuleProvider(_this.model.state, _this.devtools, _this.model, options.useLegacyStateApi || false);
        return _this;
    }
    FluentController.prototype.addModule = function (path, module) {
        var pathArray = path.split('.');
        var moduleKey = pathArray.pop();
        if (!moduleKey) {
            return throwError('Can not find module path to add module');
        }
        var parentModule = getModule(pathArray, this.module);
        var newModule = module.create(this, pathArray.concat(moduleKey));
        if (!parentModule.modules || !parentModule.modules[moduleKey]) {
            return throwError('Can not find module path to add module');
        }
        parentModule.modules[moduleKey] = newModule;
        if (newModule.providers) {
            Object.assign(this.contextProviders, newModule.providers);
        }
        updateIn(this.state, pathArray.concat(moduleKey), function (parentState, key) {
            parentState[key] = observable(newModule.state);
        });
        updateIn(this.signals, pathArray.concat(moduleKey), function (parentState, key) {
            parentState[key] = Object.keys(newModule.signals).reduce(function (signals, key) {
                signals[key] = newModule.signals[key];
                return signals;
            }, {});
        });
        this.emit('moduleAdded', path.split('.'), newModule);
    };
    FluentController.prototype.removeModule = function (path) {
        var _this = this;
        if (!path) {
            console.warn('Controller.removeModule requires a Module Path');
            return null;
        }
        var pathArray = path.split('.');
        var moduleKey = pathArray.pop();
        var parentModule = getModule(pathArray, this.module);
        if (!moduleKey || !parentModule || !parentModule.modules) {
            return throwError('Module you are trying to remove does not exist');
        }
        var module = parentModule.modules[moduleKey];
        if (module.providers) {
            Object.keys(module.providers).forEach(function (provider) {
                delete _this.contextProviders[provider];
            });
        }
        delete parentModule.modules[moduleKey];
        updateIn(this.state, pathArray.concat(moduleKey), function (parentState) {
            delete parentState[moduleKey];
        });
        updateIn(this.signals, pathArray.concat(moduleKey), function (parentSignals) {
            delete parentSignals[moduleKey];
        });
        this.emit('moduleRemoved', path, module);
    };
    return FluentController;
}(BaseControllerClass));
export { FluentController };
export function Controller(rootModule, options) {
    if (options === void 0) { options = {}; }
    options.Model = Model;
    options.Model.useLegacyStateApi = options.useLegacyStateApi;
    return new FluentController(rootModule, options);
}
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/kryd0s/tmp/widgetbot/node_modules/@cerebral/fluent/es/index.js
// module id = 26
// module chunks = 0